import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZalamoLocalClientService } from 'ZalamoLibrary/src/lib/ui/zalamo-local-client/zalamo-local-client.service';
import { RawBrowserComponent } from './raw-browser/raw-browser.component';
import { MatIconModule } from '@angular/material/icon';
import { LocalClientTasksListComponent } from './local-client-tasks-list/local-client-tasks-list.component';
import { ZalamoElementNameModule } from 'ZalamoLibrary/src/lib/zalamo/pipes/names/zalamo-element-name/zalamo-element-name.module';
import { ButtonModule } from '@ui/button/button/button.module';
import { LocalClientSubTasksComponent } from './local-client-sub-tasks/local-client-sub-tasks.component';
import { ParseLocalClientArgsPipe } from './local-client-sub-tasks/parse-local-client-args.pipe';
import { SideDialogModule } from '@ui/side-dialog';
import { LocalClientSettingsComponent } from './local-client-settings/local-client-settings.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from '@ui/form/checkbox/checkbox.module';

@NgModule({
  declarations: [],
  exports: [RawBrowserComponent],
  imports: [
    RawBrowserComponent,
    LocalClientSettingsComponent,
    LocalClientTasksListComponent,
    LocalClientSubTasksComponent,
    ParseLocalClientArgsPipe,
    CommonModule,
    MatIconModule,
    ZalamoElementNameModule,
    ButtonModule,
    SideDialogModule,
    ReactiveFormsModule,
    CheckboxModule,
  ],
  providers: [ZalamoLocalClientService],
})
export class ZalamoLocalClientModule {
  constructor(@Optional() @SkipSelf() parentModule?: ZalamoLocalClientModule) {
    if (parentModule) {
      throw new Error(
        'ZalamoLocalClientModule is already loaded. Import it in the BookingFrontModule only',
      );
    }
  }
}
